import { useTranslation } from "react-i18next";

import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";
import type { TFunction } from "i18next";
import type { TyreDiscountCategory } from "models";

const formatCategories = (categories: TyreDiscountCategory[], t: TFunction): DropdownItemProps[] =>
  categories.map(({ id, name }) => ({ key: id, value: id, text: t(`v8_${name}`, name) }));

export const useCategoriesQuery = () => {
  const { t } = useTranslation();

  const canListTyreDiscountCategories = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.TyreDiscountCategories);

  return useTypedQuery({
    queryKey: TyreDiscountsDashboardQueryKeys.categories,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.tyre_discount_categories,
    select: categories => formatCategories(categories, t),
    enabled: canListTyreDiscountCategories
  });
};
